import axios from "axios";
import { serviceUrl } from "../../config";
import { checkSessionIsActive, getSessionData } from "../utilfunctions/utilFunctions";
import { resetSession } from "./sessions";
const BACKEND_URL = serviceUrl;

export const getTableData = async (serviceName, reqData) => {
    try {
        const sessionData = getSessionData();
        const data = JSON.stringify({
            svc: "table_services",
            pid: serviceName,
            dat: reqData,
            ...sessionData
        })

        const config = {
            method: "post",
            url: BACKEND_URL,
            headers: {
              "Content-Type": "application/json",
            },
            data: data,
        };
      
        const response = await axios(config);
        const sessionActive = checkSessionIsActive(response.data);
        if (!sessionActive) {
          resetSession();
          return;
        }
    
        return response.data;
    }
    catch (error) {
        console.log(error);
    }
}

export const getConfigData = async (url) => {
    try {
        const sessionData = getSessionData();
        const data = JSON.stringify({
            svc: "table_services",
            pid: "getConfigData",
            dat: {
                url: url
            },
            ...sessionData
        })

        const config = {
            method: "post",
            url: BACKEND_URL,
            headers: {
              "Content-Type": "application/json",
            },
            data: data,
        };
      
        const response = await axios(config);
        const sessionActive = checkSessionIsActive(response.data);
        if (!sessionActive) {
          resetSession();
          return;
        }
    
        return response.data;
    }
    catch (error) {
        console.log(error);
    }
}